import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import './quasar';
import './style/media.less';
import './style/webview.less';
import './style/artical.less';

const unsync = sync(store, router);
unsync();

router.afterEach((to, form) => {
    window.scrollTo(0, 0);
    if (window._czc) {
        const content_url = to.fullPath;
        const referer_url = form.path;
        window._czc.push(['_trackPageview', content_url, referer_url]);
    }
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');

export { store, router };
